// Zentrale statische Ablage der beim PA-Start gesetzten Angular-Services für die PA-Klassen.
// Früher lagen diese Statics auf den Klassen selbst (z. B. PAOperation.operationService) —
// dadurch mussten andere Klassen sie als Wert importieren und es entstanden Import-Zyklen.
// Diese Datei importiert nur Typen (beim Kompilieren gelöscht) und ist damit zyklenfrei.
import type { OperationService } from "src/app/_services/operation.service";
import type { TicketService } from "src/app/_services/ticket.service";
import type { PlanningAssistantService } from "src/app/_services/planning-assistant.service";
import type { TechnicianDataLoader } from "./technician-data-loader";

export class PAApiServices {
  static operationService: OperationService
  static ticketService: TicketService
  static planningAssistantService: PlanningAssistantService
  static technicianDataLoader: TechnicianDataLoader
}
